import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {GET_LIST, GET_ONE} from 'react-admin';

import {HTTP_GET /*, HTTP_POST, HTTP_DELETE */} from '../common/HttpService';

const resourceBaseUlr = apiUrl + '/client/transaction';

const getClientTransactionRequest = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/id/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getClientTransactionRequests = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;
  let {filter} = params;
  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(filter)
  };

  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const ClientTransactionDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getClientTransactionRequests(params);

    case GET_ONE:
      return getClientTransactionRequest(params);

    default:
      return Promise.reject('Unknown Type');
  }
};

export default ClientTransactionDataProvider;
